import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { useState, useEffect, useCallback } from "react";
import { API_URL } from "../config";
import { authFetch } from "../utils/authFetch";
import { toast } from 'react-toastify';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import BindingCards from "./BindingCards";


export default function BecomeSeller({ userData, onSellerChange }) {
  const [search] = useSearchParams();
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isActiveSub, setIsActiveSub] = useState(false);
  const [isSeller, setIsSeller] = useState(false);
  const [hasCard, setHasCard] = useState(false);
  const [cards, setCards] = useState([]);
  const [binding, setBinding] = useState(false);
  const [subPrice, setSubPrice] = useState(0);

  const fetchSubPrice = async () => {
    try {
      const res = await authFetch(`${API_URL}/settings`, { method: "GET" });
      if (!res.ok) return;
      const data = await res.json();
      setSubPrice(data.settings.sub_price || 0);
    } catch (e) {
      console.error('Ошибка при получении цены подписки:', e);
    }
  };

   // === 1) Универсальное обновление статуса ===
  const refreshSeller = useCallback(async () => {
    try {
      const r = await authFetch(`${API_URL}/about-user`, { method: "GET" });
      if (!r.ok) return;
      const me = await r.json();
      setIsActiveSub(me.is_active_subscription);
      setHasCard(me.has_card);
      if (me.has_card === true && me.is_active_subscription === true) {
          setIsSeller(true);
      }
      else {
        setIsSeller(false);
      }
      if (typeof onSellerChange === 'function') {
        onSellerChange(isSeller);
      }
    } catch {}
  }, []);

  useEffect(() => {
    refreshSeller();
    fetchSubPrice();
  }, [refreshSeller]);

    const fetchPayoutCards = async () => {
      const token = localStorage.getItem('token');
      const res = await authFetch(`${API_URL}/seller/card-payouts-info/details`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) return [];
      const data = await res.json();
      return Array.isArray(data.cards) ? data.cards : [];
    };

  const loadCards = async () => {
    try {
      const list = await fetchPayoutCards();
      setCards(list);
      if (cards.length !== 0) {
        setHasCard(true);
      }
      else {
        setHasCard(false);
      }
      return list;
    } catch (e) {
      console.error('Ошибка при получении карт:', e);
      setCards([]);
      return [];
    }
  };

  useEffect(() => {
    const purchase = search.get('purchaseResult');
    if (purchase === 'success') toast.success('Подписка оформлена');
    if (purchase === 'failure') toast.error('Не удалось оформить подписку');
    refreshSeller();
  }, [search, refreshSeller]);

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('bindingResultSub') === 'success') {
      setIsActiveSub(true);
      loadCards();
      refreshSeller();
    }
  }, [location.search]);
  

  const subscribe = async () => {
    const jwt = localStorage.getItem("token");
    if (!jwt) {
      alert("Пожалуйста, войдите");
      return;
    }
    if (!agreeTerms) return;

    try {
      setLoading(true);
      const res = await authFetch(`${API_URL}/seller/subscription`, {
        method: "POST",
      });

      if (res.status === 401) {
        alert("Сессия истекла. Войдите заново.");
        return;
      }
      if (!res.ok) {
        const detail = await res.text().catch(() => "");
        alert(`Не удалось оформить подписку. ${detail || ""}`);
        return;
      }

      const data = await res.json();
      if (data?.paymentUrl) {
        window.location.href = data.paymentUrl; // редирект на оплату Т-Банка
      } else {
        return alert("Сервис вернул некорректный ответ (нет paymentUrl).");
      }


    } catch (e) {
      console.error(e);
      alert("Произошла ошибка при оформлении подписки.");
    } finally {
      setLoading(false);
    }
  };

  async function handleBindingCard() {
    setBinding(true);
    try {
      const jwt = localStorage.getItem('token');
      if (!jwt) return alert('Пожалуйста, войдите');

      // Запустить привязку карты
      const res = await authFetch(`${API_URL}/seller/bind-card-payouts`, {
        method: 'POST',
      });
      if (!res.ok) {
        return alert('Не удалось начать привязку карты');
      }

      const { paymentUrl, requestKey, customerKey } = await res.json();

      if (!paymentUrl) return alert('Не получили paymentUrl из ответа сервера');
      localStorage.setItem('payoutBindInProgress', '1'); // флаг для поллинга после возврата
      window.location.href = paymentUrl;
      return

    } catch (err) {
    alert(err.message);
    console.error(err);
    } finally {
    setBinding(false);
    }
  }

  useEffect(() => {
    const onFocus = () => refreshSeller();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, [refreshSeller]);


  return (
    <div className="p-3 sm:p-6 space-y-6">
        {!isSeller ? (
        <div className="text-center space-y-2 mb-8">

          <h2 className="gradient-text text-2xl sm:text-3xl font-bold mb-2">
          Стать продавцом
        </h2>
        <p className="text-gray-600 text-sm sm:text-base mb-6">
          Чтобы продавать документы, оформите подписку — {subPrice} ₽/год и привяжите карту для выплат за проданные документы.
        </p>

        <div className="bg-white p-4 sm:p-6 border rounded-lg">
          <div className="flex flex-row justify-center gap-6 mb-6">
            <div className={`border rounded-full px-6 py-4 ${isActiveSub ? "border-dashed border-gray-300" : "border-dashed border-green-300"}`}>
              <p>
                1
              </p>
            </div>
            <div className={`border rounded-full px-6 py-4 ${isActiveSub ? "border-dashed border-green-300" : "border-dashed border-gray-300"}`}>
              <p>
                2
              </p>
            </div>
          </div>
          {!isActiveSub ? (
            <div className="bg-white p-4 sm:p-6 border-b rounded-lg">
              <div className="flex items-start gap-3 justify-center mb-2">
                <input
                  type="checkbox"
                  id="terms"
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                  className="
                    mt-1 h-4 w-4 min-w-[16px] rounded border-gray-300
                    text-indigo-600 focus:ring-2 focus:ring-indigo-500
                  "
                />
                <Label
                  htmlFor="terms"
                  className="block max-w-[520px] text-[12px] text-gray-600 leading-relaxed"
                >
                  Согласен с условиями подписки (ежегодное списание {subPrice} ₽).
                </Label>
              </div>

              <Button
                type="button"
                onClick={subscribe}
                disabled={!agreeTerms || loading}
                className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 text-white"
              >
                {loading ? "Переход к оплате..." : "Оформить подписку"}
              </Button>
          </div>
          ) : (
            <div>
              <Button
                  onClick={handleBindingCard}
                  disabled={binding}
                  className="bg-gradient-to-r from-[#3466F8] via-[#CF4EE6] to-[#F6275D] text-white"
              >
                  {binding ? 'Привязываем…' : 'Привязать карту'}
              </Button>
            </div>
          )}
          
        </div>
      </div>

        ) : (
          <div className="text-center space-y-2 mb-8">
            <h2 className="gradient-text text-2xl sm:text-3xl font-bold">
              Вы продавец
            </h2>
          </div>
        )}
        
    </div>
  );
}
